<template lang="html">
  <div>
    <b-modal modal-class="modal-cv-templ" ref="modal-cv-portfolio" size="lg" title="Portafolio laboral" @hidden="hiddenModal()" no-close-on-esc no-close-on-backdrop centered hide-footer>

      <b-form class="px-2" @submit.prevent="onSubmit($event.target)" v-if="showForm">
        <div class="row align-items-center">
          <b-form-group class="col-lg-6 custom-f-group-1 txt-sm" label="Título corto:">
            <b-form-input
              v-model="formPtf.titulo"
              type="text"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="col-lg-6 custom-f-group-1 txt-sm" label="Archivo:">
           <!--  <b-form-file
              plain
              v-model="formPtf.file"
              :state="Boolean(formPtf.file)"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
            ></b-form-file> -->
            <input type="file" accept="pdf" name="document">
          </b-form-group>

          <div class="col-12 mt-2">
            <b-form-checkbox
              required
              class="mb-3 custom-checkbox-s1"
              v-model="formPtf.check"
              name="checkbox-1"
              value="accepted"
              :unchecked-value="null">
              Al hacer clic en la casilla de verificación, acepta nuestros <router-link to="">Términos y condiciones</router-link> y <router-link to="">Política de privacidad</router-link>
            </b-form-checkbox>

            <b-button type="submit" v-if="!editing" class="btn-HelvNeu btn-squ-cur-1 px-4 btn-send">Agregar</b-button>
            <b-button type="submit" v-else class="btn-HelvNeu btn-squ-cur-1 px-4 btn-send">Editar</b-button>
          </div>

        </div>
      </b-form>

    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    id: {
      default: null
    }
  },

  data(){
    return{
      showForm: false,

      formPtf: {
        cvdescription: null,
        check: null,
      }
    }
  },

  methods: {
    hiddenModal(){
      this.$parent.selectedModalCV = null;
      this.$parent.editing = false;
      this.$parent.ptfID = null;
    },

    onSubmit(form) {
      var data=tools.params(form,this.formPtf);
      axios.post(tools.url("/api/admin/updateCvPortafolios"),data).then((response)=>{
            this.$root.auth();
            this.savedmsg = 'Información guardada correctamente';
            this.$refs['modal-cv-portfolio'].hide(); // Ocultar modal despues de guardar

            
        }).catch((error)=>{
            alert('Ocurrio un error al guardar la información');

        });
    },
  },

  mounted(){
    if(this.editing){
      console.log('Consultar la info de la BD para agregarla al "formPtf"');
    }

    this.$refs['modal-cv-portfolio'].show();

    setTimeout( ()=>{ this.showForm = true; }, 500);
  },
}
</script>
